// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__XD1ko","small":"Badge_small__ilOej","action":"Badge_action__Jo25Y","alert":"Badge_alert__+3k6e","hasSpinner":"Badge_hasSpinner__TsUU9"};